import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TopNav from '@/views/components/TopNav.vue';
import BottomMsg from '@/views/components/BottomMsg.vue';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import http from '@/http'
import { addSign } from '@/http/addSign'

import { useUserStore, useComDataStore } from '@/store'
import { storeToRefs } from 'pinia';

import { isShowBottomMsg } from '@/config/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const routerReady = ref(false);

const isShowTop = computed(() => routerReady.value && !route.meta.hideTopNav)
const isShowBottom = computed(() => routerReady.value && isShowBottomMsg && !route.meta.hideBottomMsg);
onMounted(async () => {
  await router.isReady();
  await nextTick();
  routerReady.value = true;
});


const userStore = useUserStore()
const { tokenAction, userInfoAction, authReadyAction } = userStore
const { token } = storeToRefs(userStore)
const initFn = async () => {
  const res = await http.init({ client: 'pc' })
  const { initDataAction } = useComDataStore()
  initDataAction.save(res.data as any)
  if (res.code == 200 && token.value) {
    if (!route.meta.noTokenLogin) {
      const tokenRes = await http.tokenLogin(addSign({
        access_token: token.value
      }))
      if (tokenRes.code == 200) {
        tokenAction.save(tokenRes.data.access_token)
        userInfoAction.save({
          uname: tokenRes.data.uname,
          uid: tokenRes.data.uid,
          vname: tokenRes.data.vname,
        })
      } else {
        tokenAction.clear()
        userInfoAction.clear()
      }
    }
  }
  authReadyAction.save()
}

initFn()




return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowTop.value)
      ? (_openBlock(), _createBlock(TopNav, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (isShowBottom.value)
      ? (_openBlock(), _createBlock(BottomMsg, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})